var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLessonDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 42,
    viewBox: "0 0 6 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1a.5.5 0 00-1 0h1zM3 42l2.887-5H.113L3 42zM2.5 1v36.5h1V1h-1z",
    fill: "#1D7777"
  })));
}
export default SvgArrowLessonDown;